import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../../controller/BaseController";
import { Button$PressEvent } from "sap/m/Button";
import Validator from "../../util/Validator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class DepartmentsController extends BaseController {

    public async onInit(): Promise<void> {

        const availableStatus: Object[] = [];

        this.getClient().enums.Status.values().forEach((value) => {
            availableStatus.push({ key: value, name: value });
        })

        // // Create a new JSON model for the view
        const viewModel = new JSONModel({
            busy: false,
            limit: 5,
            departments: undefined,
            selectedDepartments: undefined,
            id: undefined,
            departmentId: undefined,
            name: undefined,
            status: undefined,
            selectedStatus: [],
            availableStatus: availableStatus,
            organizationID: undefined

        });

        this.setModel(viewModel, "viewModel");
        // await this.fetchData();

    }


    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    async onCreateDepartment(): Promise<void> {

        this.updateModelProperty("/name", undefined);

        // Open the dialog for creating a department
        await this.openDialog("DialogCreateUpdateDepartment");

    }

    async onSaveDialog(oEvent: any): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        /*
        // Get the current department
        const id = this.getModelProperty("/id");
        const departmentId = this.getModelProperty("/departmentId");*/
        const name = this.getModelProperty("/name");
        const status = this.getModelProperty("/status");

        var payload;

        // Create a new department    
        payload = await this.getClient().models.Department.create({

            name: name,
            status: status,
            organizationId: "cf0147f1-dea0-42b6-a82a-5c6119e82150"
        })

        if (payload.errors) {
            console.error(payload.errors);
        }

        // Close the dialog
        this.destroyDialog("DialogCreateUpdateDepartment");
    }

    onCloseDialog(): void {
        // Close the dialog
        this.destroyDialog("DialogCreateUpdateDepartment");
    }


    //Filter

    async onFilter(): Promise<void> {
        // Open the filter dialog
        await this.openDialog("DialogFilterDepartments");
    }

    async handleFilterDialogConfirm(oEvent): Promise<void> {
        const mParams = oEvent.getParameters();
        var aFilters: any[] = [];

        mParams.filterItems.forEach(function (oItem: any) {
            aFilters.push(oItem.getKey());
        });

        this.updateModelProperty("/selectedStatus", aFilters);
        this.filterDepartments();
    }

    filterDepartments(): void {
        // Get all departments
        const allDepartments: any = this.getModelProperty("/departments");
        const selectedStatus: any = this.getModelProperty("/selectedStatus");

        // If no status is selected, set all departments as selected departments
        if (selectedStatus.length === 0) {
            this.updateModelProperty("/selectedDepartments", allDepartments);
            return;
        }


        // Filter departments
        const selectedDepartments = allDepartments.filter((department: any) => {
            // item contains status
            const hasSelectedStatus = selectedStatus.includes(department.status);

            return hasSelectedStatus;
        });

        // update model
        this.updateModelProperty("/selectedDepartments", selectedDepartments);

    }

    onNavigateDepartment(oEvent: Button$PressEvent): void {
        // Get the path of the clicked department in the "alldepartments" model
        const currentDepartment = oEvent.getSource().getBindingContext().getObject() as any;

        this.navTo("department", {
            id: currentDepartment.id
        });
    }

}
